import axios from "./axiosConfig";
import csv from 'csvtojson';
import { apis } from './params';

export function uploadImageService(_body: any) {
    return axios({
        "method": "Post",
        "url": apis.UPLOAD_IMAGE,
        "data": _body,
        "headers": {
            "Content-Type": "multipart/form-data"
        }
    })
}

export function convertToWebp(_body: any) {
    return axios({
        "method": "Post",
        "url": apis.CONVERT_TO_WEBP,
        "data": _body
    })
}

export function uploadFileService(_body: any) {
    return axios({
        "method": "Post",
        "url": apis.UPLOAD_FILE,
        "data": _body
    })
}

export function downloadFileService(_param: string) {
    return axios({
        "method": "Get",
        "url": apis.DOWNLOAD_FILE + _param
    })
}

export function deleteFileService(_param: string) {
    return axios({
        "method": "Delete",
        "url": apis.DELETE_FILE + _param
    })
}

export function parseCSVService(csvData: any) {
    return csv().fromString(csvData)
};

export const downloadFile = (fileUrl: string, filename: string) => {
    try {
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = filename;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        a.remove();
    } catch (error) {
        console.error('Error downloading file:', error);
    }
};


export function sleep(ms: number) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}

export function getDistinctCategoryCodeByMsns(_body: any) {
    return axios({
        "method": "Post",
        "url": apis.GET_DISTINCT_CATEGORY_CODE_BY_MSNS,
        "data": _body
    })
}